<div [formGroup]="groupForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="name"
    placeholder="Admins"
    label="Name">
  </nx-edit-text-input>
<div>